export default "<input type=\"checkbox\" [attr.class]=\"defaultCss\" />"